"use client";

import { Button } from "@/components/ui/button";
import { MessagesSquareIcon } from "lucide-react";
import { useState } from "react";
import { CourseAskQuestionsModal } from "./course-ask-questions-modal";

export const CourseAskQuestions = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="bg-remedium-blue/5 flex items-center justify-between rounded-xl p-4">
        <div className="flex items-center gap-4">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-lg bg-white">
            <MessagesSquareIcon className="h-7 w-7" color={"#2E35FF"} />
          </div>
          <div className="flex flex-col gap-1.5">
            <p className="font-bold">Masz pytania do kursu?</p>
            <p className="text-sm text-zinc-600">
              Skontaktuj się z nami – z przyjemnością pomożemy!
            </p>
          </div>
        </div>
        <Button variant="blue" onClick={() => setIsModalOpen(true)}>
          Wyślij wiadomość
        </Button>
      </div>
      <CourseAskQuestionsModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </>
  );
};
